// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"

// Import all controller files
import AsyncRadioFormController from "./async_radio_form_controller"
import BillingAdminUserTiersController from "./billing_admin_user_tiers_controller"
import ClipboardController from "./clipboard_controller"
import ClusterAdjustmentsController from "./cluster_adjustments_controller"
import CodesController from "./codes_controller"
import CollapsableSectionController from "./collapsable_section_controller"
import DraggableController from "./draggable_controller"
import DroppableController from "./droppable_controller"
import EditableController from "./editable_controller"

const application = Application.start()

// Register controllers
application.register("async-radio-form", AsyncRadioFormController)
application.register("billing-admin-user-tiers", BillingAdminUserTiersController)
application.register("clipboard", ClipboardController)
application.register("cluster-adjustments", ClusterAdjustmentsController)
application.register("codes", CodesController)
application.register("collapsable-section", CollapsableSectionController)
application.register("draggable", DraggableController)
application.register("droppable", DroppableController)
application.register("editable", EditableController)
